import script from "./VysledkySelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./VysledkySelection.vue?vue&type=script&setup=true&lang=ts"

import "./VysledkySelection.vue?vue&type=style&index=0&id=8d8b8d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d8b8d92"]])

export default __exports__